import React from 'react';
import Icon from '../../../components/AppIcon';

const TicketList = ({ tickets, onTicketClick, isStaff }) => {
  const getPriorityColor = (priority) => {
    const colors = {
      low: 'text-blue-500 bg-blue-500/10',
      medium: 'text-yellow-500 bg-yellow-500/10',
      high: 'text-orange-500 bg-orange-500/10',
      urgent: 'text-red-500 bg-red-500/10'
    };
    return colors?.[priority] || colors?.medium;
  };

  const getStatusColor = (status) => {
    const colors = {
      open: 'text-blue-500 bg-blue-500/10',
      in_progress: 'text-orange-500 bg-orange-500/10',
      resolved: 'text-green-500 bg-green-500/10',
      closed: 'text-gray-500 bg-gray-500/10'
    };
    return colors?.[status] || colors?.open;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date?.toLocaleDateString();
  };

  return (
    <div className="space-y-3">
      {tickets?.map((ticket) => (
        <div
          key={ticket?.id}
          onClick={() => onTicketClick(ticket)}
          className="bg-card border border-border rounded-lg p-4 hover:shadow-md transition-all cursor-pointer"
        >
          <div className="flex items-start justify-between mb-2">
            <div className="flex-1">
              <h3 className="font-semibold text-foreground mb-1">
                {ticket?.subject}
              </h3>
              <p className="text-sm text-muted-foreground line-clamp-2">
                {ticket?.description}
              </p>
            </div>
            <div className="ml-4 flex flex-col items-end gap-2">
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${getPriorityColor(ticket?.priority)}`}>
                {ticket?.priority?.toUpperCase()}
              </span>
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(ticket?.status)}`}>
                {ticket?.status?.replace('_', ' ')?.toUpperCase()}
              </span>
            </div>
          </div>

          <div className="flex items-center gap-4 text-xs text-muted-foreground mt-3">
            <div className="flex items-center gap-1">
              <Icon name="Tag" size={14} />
              <span>{ticket?.category?.replace('_', ' ')}</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="Clock" size={14} />
              <span>{formatDate(ticket?.created_at)}</span>
            </div>
            {isStaff && ticket?.user_profiles?.full_name && (
              <div className="flex items-center gap-1">
                <Icon name="User" size={14} />
                <span>{ticket?.user_profiles?.full_name}</span>
              </div>
            )}
            {ticket?.ai_confidence_score && (
              <div className="flex items-center gap-1">
                <Icon name="Sparkles" size={14} className="text-primary" />
                <span>AI: {Math.round(ticket?.ai_confidence_score * 100)}%</span>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TicketList;